import {
  FilterSet,
  FilterSetType,
} from "src/app/core/interfaces/filter-interface";
import { MobilityContactCardInterface } from "src/app/core/interfaces/mobility-contact-card-interface";
import {
  signalStore,
  withState,
  withMethods,
  patchState
} from "@ngrx/signals";
import { MobilityRefService } from "src/app/features/services/mobility/mobility-ref-service";
import { inject } from "@angular/core";
import { FiltersService } from "src/app/core/services/filters/filters-service";

interface MobilitySearchState {
  locationFilters: FilterSet;
  locationFiltersSelected: FilterSet;
  activitiesFilters: FilterSet;
  activitiesFiltersSelected: FilterSet;
  results: MobilityContactCardInterface[];
}

const initialState: MobilitySearchState = {
  locationFilters: null,
  locationFiltersSelected: null,
  activitiesFilters: null,
  activitiesFiltersSelected: null,
  results: [],
};

export const MobilitySearchStore = signalStore(
  { providedIn: "root" },
  withState(initialState),
  withMethods((store) => {
    const mobilityRefService = inject(MobilityRefService);
    const filtersService = inject(FiltersService);

    return {
      setFilters(locationFilters, activitiesFilters): void {
        patchState(store, {
          locationFilters,
          activitiesFilters,
        });
      },
      setFiltersSelected(
        locationFiltersSelected: FilterSet,
        activitiesFiltersSelected: FilterSet
      ): void {
        patchState(store, {
          locationFiltersSelected,
          activitiesFiltersSelected,
        });
      },
      locationFilterExists(): boolean {
        return store.locationFilters() !== null;
      },
      activitiesFilterExists(): boolean {
        return store.activitiesFilters() !== null;
      },
      anyResults(): boolean {
        return store.results().length > 0;
      },
      setResults(results: MobilityContactCardInterface[]) {
        patchState(store, { results });
      },
      async loadMobilityRefContact(): Promise<void> {
        const selectedFilters = [
          store.activitiesFiltersSelected(),
          store.locationFiltersSelected(),
        ];
        const mobilityRefContacts =
          await mobilityRefService.getMobilityRefs(selectedFilters);
        this.setResults(mobilityRefContacts);
      },
      async loadMobilityRefFilters(): Promise<void> {
        const filterGroup = await filtersService.getFilterGroup();

        const filterSetGeographicalLocation = filterGroup.filterSets.find(
          (fs) => fs.filterSetType == FilterSetType.GeographicalLocation
        );
        const filterSetActivity = filterGroup.filterSets.find(
          (fs) => fs.filterSetType == FilterSetType.Activity
        );

        this.setFilters(filterSetGeographicalLocation, filterSetActivity);
      },
      updateSelectedFiltersTranslations(): void {
        const locationFilters = store.locationFilters();
        const selectedLocationFilters = store.locationFiltersSelected();
        const activitiesFilters = store.activitiesFilters();
        const selectedActivitiesFilters = store.activitiesFiltersSelected();

        this.setFiltersSelected(
          selectedLocationFilters && locationFilters
            ? filtersService.updateFilterSetTranslations(
                selectedLocationFilters,
                locationFilters
              )
            : selectedLocationFilters,
          selectedActivitiesFilters && activitiesFilters
            ? filtersService.updateFilterSetTranslations(
                selectedActivitiesFilters,
                activitiesFilters
              )
            : selectedActivitiesFilters
        );
      },
    };
  })
);
